import PageHead from '../../../components/PageHead'
import { t } from '../../../utils'
import DevicesLimitModal from '../../../components/modals/DevicesLimitModal'
import styles from './_labLayout.module.scss'
import LabHeader from './LabHeader'
import LabFooter from './LabFooter'
import FreeTrialBanner from '../../../components/FreeTrialBanner'
import AdminMessageBlock from '../../../components/AdminMessageBlock'
import AdminSpoofingBlock from '../../../components/AdminSpoofingBlock'
import { useAuth } from '../../../utils/auth'
import LabOnboardingProvider from './LabOnboardingProvider'

interface LayoutProps {
  pageTitle?: string
  pageDescription?: string
  pageKeywords?: string
  children?: React.ReactNode
  isFooterShown?: boolean
}

const LabLayout: React.FC<LayoutProps> = ({
  children,
  pageTitle = t('WorshipOnline - Lab Plus'),
  pageDescription,
  pageKeywords,
  isFooterShown = true
}) => {
  const { isAuthenticated } = useAuth()

  return (
    <>
      <AdminSpoofingBlock />
      <AdminMessageBlock />
      <DevicesLimitModal />
      <FreeTrialBanner />
      <PageHead
        title={pageTitle}
        description={pageDescription}
        keywords={pageKeywords}
        noindex={true}
      />

      <LabHeader />

      {isAuthenticated ? (
        <LabOnboardingProvider>
          <div className={styles.mainContainer}>{children}</div>
        </LabOnboardingProvider>
      ) : (
        <div className={styles.mainContainer}>{children}</div>
      )}

      <div className={!isFooterShown ? 'is-hidden-tablet' : ''}>
        <LabFooter />
      </div>
    </>
  )
}

export default LabLayout
